import React from 'react';
import { TextField, Grid } from '@material-ui/core';
import { DeepMap, FieldError } from 'react-hook-form';

import { IntlString } from '@utils/formatter';
import CheckboxGroup from '@components/CheckboxGroup';
import { Props as CheckboxGroupPresenter } from '@components/CheckboxGroup/CheckboxGroupPresenter';
import { useCardStyle } from './styled';
import { CustomizedTypography } from '@components/Customized';

interface InputItemProps {
  name: string;
  inputProps?: any;
  errors?: DeepMap<Record<string, any>, FieldError>;
  marginBottom?: number;
}

export const InputItem = (props: InputItemProps) => {
  const { inputRoot } = useCardStyle();
  const error = props.errors && props.errors[props.name];

  const title = IntlString(`login.title.${props.name}`);
  const placeholder = IntlString(`login.placeholder.${props.name}`);
  const helperText =
    error && error.message
      ? error.message
      : IntlString(error ? `login.error.${props.name}` : '');

  return (
    <Grid container style={{ marginBottom: props.marginBottom }}>
      <Grid item xs={4}>
        <CustomizedTypography variant="body1" style={{ lineHeight: '40px' }}>
          {title}
        </CustomizedTypography>
      </Grid>

      <Grid item xs={8}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          name={props.name}
          classes={{ root: inputRoot }}
          inputProps={props.inputProps}
          placeholder={placeholder}
          error={error ? true : false}
          helperText={error && helperText}
        />
      </Grid>
    </Grid>
  );
};

interface CheckboxItemProps
  extends Pick<
    CheckboxGroupPresenter,
    'value' | 'options' | 'gridContainerProps'
  > {
  xs: any;
  name: string;
  onChange: (value: string[]) => void;
  errors?: DeepMap<Record<string, any>, FieldError>;
}

export const CheckboxItem = (props: CheckboxItemProps) => {
  const error = props.errors && props.errors[props.name];
  const helperText = IntlString(error ? `request.error.${props.name}` : '');

  return (
    <React.Fragment>
      <CheckboxGroup {...props} gridItemProps={{ xs: props.xs }} />
      {helperText && (
        <CustomizedTypography
          color="error"
          variant="caption"
          style={{ marginTop: 12 }}
        >
          {helperText}
        </CustomizedTypography>
      )}
    </React.Fragment>
  );
};
